// Tiny cart store — items persist in localStorage; only {id, qty} is stored so the
// cart ALWAYS renders the latest name/image/price from liveProducts (never stale data).
const KEY = "sbs_cart";
let items = [];
const listeners = new Set();

try { items = JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { items = []; }

const save = () => {
  try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* private mode */ }
  listeners.forEach((f) => f());
};

export const cartItems = () => items;
export const cartCount = () => items.reduce((n, i) => n + i.qty, 0);

export const addToCart = (id, qty = 1) => {
  const found = items.find((i) => i.id === id);
  if (found) found.qty = Math.min(10, found.qty + qty);
  else items.push({ id, qty });
  save();
};

export const setQty = (id, qty) => {
  const found = items.find((i) => i.id === id);
  if (!found) return;
  found.qty = qty;
  if (found.qty <= 0) items = items.filter((i) => i.id !== id);
  save();
};

export const removeFromCart = (id) => { items = items.filter((i) => i.id !== id); save(); };
export const clearCart = () => { items = []; save(); };
export const subscribeCart = (f) => { listeners.add(f); return () => listeners.delete(f); };
